module.exports = __webpack_public_path__ + "media/widgets/asc-2960f4a0.gif";